import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resultados',
  templateUrl: './resultados.component.html',
  styleUrls: ['./resultados.component.css']
})
export class ResultadosComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  irDetalle(item: any) {
   
    let dato = {
      id: item
    }
    if(item=="calles"){
      this.router.navigate(['/resultadosdetalle'], { queryParams: dato });
    }
    if(item == "alumbrado") {
      this.router.navigate(['/resultadosdetalle'], { queryParams: dato });
    }
    if(item == "limpieza") {
      this.router.navigate(['/resultadosdetalle'], { queryParams: dato });
    }
    if(item == "panteones") {
      this.router.navigate(['/resultadosdetalle'], { queryParams: dato });
    }
    if (item == "parques") {
      this.router.navigate(['/resultadosdetalle'], { queryParams: dato });
    }
    if (item == "mercado") {
      this.router.navigate(['/resultadosdetalle'], { queryParams: dato });
    }


    
  }

 
}
